import { client } from 'config/routes'
import { useAuth } from 'routes/Menu/domains/auth'

import { CtaTexts } from './data'

/**
 * Used to get cta text & uri based on condition
 * if user logged in or not
 */

export const useGetCtaProps = () => {
  const { isAuthenticated } = useAuth()

  const { menu, signup } = client

  if (!isAuthenticated) {
    return {
      ctaUri: signup,
      ctaText: CtaTexts.GET_STARTED,
    }
  }

  return {
    ctaUri: menu,
    ctaText: CtaTexts.SEE_MENU,
  }
}
